export default __webpack_public_path__ + "static/media/bannerr3.ea077f0d.webp";